import { render, staticRenderFns } from "./BdMain.vue?vue&type=template&id=80b14f2c&scoped=true&"
import script from "./BdMain.vue?vue&type=script&lang=js&"
export * from "./BdMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b14f2c",
  null
  
)

export default component.exports